/**
 * CATMATIK — tracker d'événements.
 * Autonome, sans dépendance. Configuré par window.CMK (injecté dans theme.liquid).
 */
(function () {
  'use strict';

  var CFG = window.CMK || {};
  if (!CFG.endpoint) return;

  var SESSION_MAX_IDLE = 30 * 60 * 1000;   // 30 min
  var ATTRIB_TTL       = 90 * 24 * 3600e3; // 90 j — fenêtre d'attribution Google Ads
  var FLUSH_MS         = 3000;

  /* ── stockage tolérant (navigation privée, cookies bloqués) ── */
  function ls(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, val); return val;
    } catch (e) { return null; }
  }
  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val); return val;
    } catch (e) { return null; }
  }
  /** Stockage partagé par tous les onglets, avec repli sur celui de l'onglet. */
  function st(key, val) { var r = ls(key, val); return r !== null ? r : ss(key, val); }
  function uid() {
    try { return crypto.randomUUID(); }
    catch (e) { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  }

  /* ── visites internes (le propriétaire, pas un client) ──
     ?cmk_interne=1 marque durablement ce navigateur, ?cmk_interne=0 retire la marque.
     La prévisualisation de thème et l'éditeur Shopify sont toujours internes. */
  (function () {
    var q = location.search;
    if (q.indexOf('cmk_interne=1') !== -1) ls('cmk_interne', '1');
    if (q.indexOf('cmk_interne=0') !== -1) { try { localStorage.removeItem('cmk_interne'); } catch (e) {} }
  })();
  var interne = ls('cmk_interne') === '1' ||
    location.search.indexOf('preview_theme_id') !== -1 ||
    !!(window.Shopify && window.Shopify.designMode);

  /* ── identité ──
     Fixée en tête de page par snippets/cmk-tracker-head.liquid (window.CMK_CORE), avec les
     mêmes règles qu'ici. Le stockage fait foi ; CMK_CORE sert quand il est indisponible
     (navigation privée), pour que les deux scripts parlent de la même session. */
  var CORE = window.CMK_CORE || {};
  var PN = CORE.pn || 1; // rang de la page dans la session : 1 = page d'atterrissage
  var visitorId = ls('cmk_vid') || CORE.vid || ls('cmk_vid', uid()) || uid();

  // Session partagée entre onglets (voir snippets/cmk-tracker-head.liquid).
  var lastSeen = +(st('cmk_seen') || 0);
  var sessionId = st('cmk_sid');
  if (!sessionId && CORE.sid) { sessionId = CORE.sid; lastSeen = Date.now(); }
  if (!sessionId || Date.now() - lastSeen > SESSION_MAX_IDLE) sessionId = st('cmk_sid', uid()) || uid();
  st('cmk_seen', Date.now());

  /* ── attribution : capturée à l'arrivée, conservée 90 jours ── */
  var params = new URLSearchParams(location.search);
  // Les URL du flux Shopping portent DEUX jeux d'UTM : ceux que l'app Google de Shopify
  // écrit dans le flux (utm_campaign=sag_organic), puis le suffixe de la campagne.
  // get() rendrait le premier ; c'est le dernier, celui de la campagne, qui fait foi.
  var _get = params.get.bind(params);
  params.get = function (k) {
    var tous = params.getAll(k);
    return tous.length ? tous[tous.length - 1] : _get(k);
  };
  var attrib;
  try { attrib = JSON.parse(ls('cmk_attrib') || 'null'); } catch (e) { attrib = null; }

  var incomingGclid = params.get('gclid') || params.get('wbraid') || params.get('gbraid');
  // Pinterest marque ses clics avec ?epik= : c'est son équivalent du gclid, et le seul moyen
  // de rattacher une vente à une épingle. Les clics venus de l'application mobile Pinterest
  // arrivent sans referrer : sans ce paramètre, ils passent pour du trafic direct.
  var incomingEpik = params.get('epik');
  var incomingUtm = params.get('utm_source');
  var expired = !attrib || Date.now() - (attrib.t || 0) > ATTRIB_TTL;

  // Un nouveau clic payant écrase toujours l'attribution précédente (last non-direct click).
  if (incomingGclid || incomingEpik || incomingUtm || expired) {
    attrib = {
      t: Date.now(),
      gclid: incomingGclid || (expired ? null : attrib && attrib.gclid) || null,
      epik: incomingEpik || (expired ? null : attrib && attrib.epik) || null,
      utm_source: params.get('utm_source') || (expired ? null : attrib && attrib.utm_source) || null,
      utm_medium: params.get('utm_medium') || (expired ? null : attrib && attrib.utm_medium) || null,
      utm_campaign: params.get('utm_campaign') || (expired ? null : attrib && attrib.utm_campaign) || null,
      // Le mot-clé et le groupe d'annonces : ce qui dit quelle requête rapporte.
      utm_term: params.get('utm_term') || (expired ? null : attrib && attrib.utm_term) || null,
      utm_content: params.get('utm_content') || (expired ? null : attrib && attrib.utm_content) || null,
      landing_page: location.pathname + location.search,
      referrer: document.referrer && document.referrer.indexOf(location.host) === -1 ? document.referrer : null,
    };
    ls('cmk_attrib', JSON.stringify(attrib));
  }

  // Figé pour la durée de la session : un redimensionnement de fenêtre ne doit pas
  // faire basculer une même session de « desktop » à « mobile » dans les stats.
  var deviceType = ss('cmk_dev');
  if (!deviceType) {
    var w0 = window.innerWidth;
    deviceType = ss('cmk_dev', w0 < 768 ? 'mobile' : w0 < 1024 ? 'tablet' : 'desktop') ||
                 (w0 < 768 ? 'mobile' : w0 < 1024 ? 'tablet' : 'desktop');
  }
  function device() { return deviceType; }

  /* ── temps depuis l'arrivée (le clic), et rang de page dans meta.p ── */
  var base = 0;
  function now() { return window.performance && performance.now ? performance.now() : 0; }
  function sec() { return Math.round((now() - base) / 100) / 10; }
  function metaP(m) { m.p = PN; return JSON.stringify(m); }

  /* ── file d'attente ── */
  var queue = [];
  var timer = null;

  function flush(sync) {
    if (!queue.length) return;
    var payload = JSON.stringify(queue.splice(0, 50));
    clearTimeout(timer); timer = null;

    // sendBeacon survit à la fermeture de l'onglet ; fetch sert au cas où il est indisponible.
    var sent = false;
    if (sync && navigator.sendBeacon) {
      try { sent = navigator.sendBeacon(CFG.endpoint, new Blob([payload], { type: 'text/plain' })); } catch (e) {}
    }
    if (!sent) {
      try {
        fetch(CFG.endpoint, {
          method: 'POST', body: payload, keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
        }).catch(function () {});
      } catch (e) {}
    }
  }

  function track(name, props) {
    var e = props || {};
    e.name = name;
    e.client_ts = Date.now();
    e.visitor_id = visitorId;
    e.session_id = sessionId;
    e.path = location.pathname;
    e.device = device();
    e.template = CFG.template || null;
    if (e.product_id === undefined && CFG.productId) e.product_id = CFG.productId;
    if (e.label === undefined && CFG.productTitle && e.product_id) e.label = CFG.productTitle;
    e.gclid = attrib.gclid;
    e.epik = attrib.epik;
    e.utm_source = attrib.utm_source;
    e.utm_medium = attrib.utm_medium;
    e.utm_campaign = attrib.utm_campaign;
    e.utm_term = attrib.utm_term;
    e.utm_content = attrib.utm_content;
    e.referrer = attrib.referrer;
    e.landing_page = attrib.landing_page;

    // Navigateur piloté par un robot (Selenium, Puppeteer…) : le serveur le marque comme tel.
    try { if (navigator.webdriver === true) e.wd = true; } catch (x) {}
    if (interne) e.int = true;
    queue.push(e);
    versClarity(name);
    st('cmk_seen', Date.now());
    if (!timer) timer = setTimeout(function () { flush(false); }, FLUSH_MS);
  }
  window.cmkTrack = track;

  /* ── Pont vers Microsoft Clarity ──
     Sans ce lien, retrouver la vidéo d'une session vue dans ce tableau de bord revient à
     chercher une aiguille parmi toutes les sessions Clarity. On pose donc sur chaque session
     Clarity notre identifiant de session et la campagne, et on y marque les étapes clés :
     elles deviennent filtrables dans Clarity (Filtres → Tags personnalisés / Événements). */
  var CLARITY_EVENTS = {
    add_to_cart_click: 1, add_to_cart: 1, cart_open: 1, checkout_start: 1,
    offre_open: 1, faq_open: 1, rage_click: 1, mobile_nav_open: 1,
    sticky_ouvert: 1, sticky_ajout: 1,
  };
  // « upgrade » demande à Clarity de conserver l'enregistrement en priorité.
  var CLARITY_UPGRADE = { add_to_cart_click: 1, add_to_cart: 1, checkout_start: 1 };
  var clarityTagge = false;
  function versClarity(name) {
    var c = window.clarity;
    if (typeof c !== 'function') return;
    try {
      if (!clarityTagge) {
        clarityTagge = true;
        // identify remplit les champs « ID d'utilisateur personnalisé » et
        // « ID de session personnalisé » des filtres Clarity.
        c('identify', visitorId, sessionId);
        c('set', 'cmk_session', sessionId);
        c('set', 'cmk_visitor', visitorId);
        if (attrib.utm_campaign) c('set', 'cmk_campagne', attrib.utm_campaign);
        c('set', 'cmk_paye', attrib.gclid ? 'oui' : 'non');
      }
      if (CLARITY_EVENTS[name]) c('event', name);
      if (CLARITY_UPGRADE[name]) c('upgrade', name);
    } catch (e) {}
  }

  /* ── le gclid et les identifiants doivent voyager jusqu'à la commande Shopify ──
     Poussé pour TOUT LE MONDE, pas seulement pour le trafic payant : les attributs du panier
     sont le seul lien entre la session et l'achat quand le pixel du checkout ne retrouve pas
     le stockage du navigateur (navigation privée, bac à sable). Les limiter au trafic payant
     laissait les achats en direct et en organique rattachés à un identifiant « pixel-… ». */
  var attribPushed = false;
  function pushAttribToCart() {
    if (attribPushed) return;
    attribPushed = true;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            gclid: attrib.gclid || '',
            epik: attrib.epik || '',
            utm_source: attrib.utm_source || '',
            utm_campaign: attrib.utm_campaign || '',
            cmk_visitor: visitorId,
            cmk_session: sessionId,
          },
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── vue de page ──
     meta.tjs : ms entre le clic et le lancement de ce script, chargé en fin de page ;
     vw / vh : la zone visible réelle, c'est-à-dire ce que contient le premier écran. */
  track('page_view', { meta: metaP({ tjs: Math.round(now()), vw: window.innerWidth, vh: window.innerHeight }) });
  // On se fie à la présence du produit, pas au nom du gabarit : celui-ci porte un
  // suffixe sur les gabarits alternatifs (« product.capsule »).
  if (CFG.productId) {
    track('product_view', { value: CFG.productPrice || null, currency: 'EUR' });
  }
  // Envoyées tout de suite : attendre 3 s perdait les visiteurs qui partent entre-temps.
  flush(false);

  /* ── clics (délégation : robuste au contenu chargé après coup) ── */
  // Le thème a plusieurs gabarits produit avec des boutons différents
  // (.overlay-buy_button sur le gabarit standard, .offre__cta sur « capsule »).
  // On identifie donc le formulaire d'ajout, pas le bouton : ça vaut pour tous les gabarits.
  var CART_FORM = 'form[action*="/cart/add"]';
  var lastAtc = 0; // un clic sur le bouton déclenche aussi le submit : ne compter qu'une fois

  /** Seul un bouton qui soumet compte : type="button" ouvre un volet, il n'ajoute rien. */
  function submits(el) {
    var t = (el.getAttribute('type') || '').toLowerCase();
    return el.tagName === 'INPUT' ? t === 'submit' : (t === '' || t === 'submit');
  }

  /** Le bouton d'un formulaire peut vivre hors de celui-ci via l'attribut form="…". */
  function cartFormOf(el) {
    if (!el) return null;
    var inside = el.closest(CART_FORM);
    if (inside) return inside;
    var btn = el.closest('[form]');
    if (btn) {
      var f = document.getElementById(btn.getAttribute('form'));
      if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) return f;
    }
    return null;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // Agrandissement d'une photo de la galerie produit.
    // Sur ordinateur, glisser le carrousel à la souris produit aussi un clic : on l'écarte
    // s'il suit de près un changement de photo.
    if (t.closest('a[data-fancybox^="product-gallery"]')) {
      if (Date.now() - galChange > 400) track('galerie_zoom', { value: galActuelle + 1, meta: metaP({ t: sec() }) });
      return;
    }

    // Menu de navigation mobile
    if (t.closest('a[href="#nav"], [aria-controls="nav"]')) {
      track('mobile_nav_open');
      return;
    }

    // Sélecteur d'offre. Testé avant l'ajout au panier : ces boutons sont À L'INTÉRIEUR
    // du formulaire d'ajout sans rien soumettre.
    // Deux thèmes coexistent : « offre__ » (thème publié) et « pas__ » (chantier CRO).
    if (t.closest('[data-offre-invite], .offre__invite, [data-pas-invite], .pas__invite')) {
      track('offre_open'); return;
    }
    if (t.closest('[data-offre-fermer], .offre__fermer, [data-pas-fermer], .pas__fermer')) {
      track('offre_close'); return;
    }
    if (t.closest('[data-pas-replie], .pas__replie')) { track('offre_replie'); return; }

    // Ajout au panier — le clic, pas encore l'ajout réussi.
    // .overlay-buy_button est ajouté en secours : sur capsule il référence un
    // formulaire absent de la page, donc cartFormOf() ne peut pas le rattacher.
    var btn = t.closest('button, input[type="submit"]');
    if (btn && submits(btn) &&
        (cartFormOf(btn) || btn.closest('.overlay-buy_button, .offre__cta, .pas__achat'))) {
      lastAtc = Date.now();
      track('add_to_cart_click', {
        variant_id: currentVariant(),
        label: (btn.textContent || '').trim().slice(0, 60) || null,
      });
      pushAttribToCart();
      return;
    }

    // Preuve sociale du gabarit capsule : un visiteur qui fouille les avis hésite.
    if (t.closest('[data-au-pack], .au__conseil-cta'))    { track('pack_cta'); return; }
    if (t.closest('[data-avis-more], .avis__more'))       { track('avis_voir_plus'); return; }
    if (t.closest('[data-avis-zoom], .avis__photo'))      { track('avis_photo_zoom'); return; }
    if (t.closest('[data-avis-lire], .avis__lire'))       { track('avis_lire_suite'); return; }

    // Ouverture d'une question FAQ = une objection identifiée.
    // Thème publié : <button aria-expanded>. Chantier CRO : <details><summary>.
    var faq = t.closest('.faq-luxury__question');
    if (faq) {
      if (faq.getAttribute('aria-expanded') !== 'true') {
        track('faq_open', { label: (faq.textContent || '').trim().slice(0, 200) });
      }
      return;
    }
    var sum = t.closest('summary.cmk-faq__sum, .cmk-faq__sum');
    if (sum) {
      // Au moment du clic, <details> n'a pas encore basculé : open=false = ouverture.
      var det = sum.closest('details');
      if (!det || !det.open) {
        track('faq_open', { label: (sum.textContent || '').trim().slice(0, 200) });
      }
      return;
    }

    // Vidéos clients : « ugc-video-card » (thème publié), « cmk-videos » (chantier CRO).
    var vid = t.closest('.ugc-video-card__play, .cmk-videos__item');
    if (vid) {
      track('ugc_video_play', { label: (vid.getAttribute('aria-label') || '').slice(0, 80) || null });
      return;
    }

    // Sections dépliantes du chantier CRO : elles portent les objections du produit.
    var dep = t.closest('.cmk-odeurs__btn, .cmk-entretien__btn');
    if (dep) {
      track('section_open', {
        label: (dep.textContent || '').trim().slice(0, 80) ||
               dep.className.split(' ')[0] || null,
      });
      return;
    }

    if (t.closest('a[href*="/cart"], .side-cart-trigger, [data-side-cart]')) { track('cart_open'); return; }

    if (t.closest('[name="checkout"], a[href*="/checkout"]')) { track('checkout_start'); pushAttribToCart(); return; }

    // Sélection de variante
    var sw = t.closest('[class*="swatch"], .product-form__input label, input[name^="option"]');
    if (sw) {
      track('variant_select', { label: (sw.getAttribute('title') || sw.textContent || '').trim().slice(0, 100) || null });
    }
  }, true);

  // Filet : un formulaire peut être soumis par la touche Entrée ou par du JS,
  // sans qu'aucun bouton n'ait été cliqué.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.matches && f.matches(CART_FORM) && Date.now() - lastAtc > 1000) {
      lastAtc = Date.now();
      track('add_to_cart_click', { variant_id: currentVariant(), label: 'submit' });
      pushAttribToCart();
    }
  }, true);

  function currentVariant() {
    var i = document.querySelector(CART_FORM + ' [name="id"]:checked') ||
            document.querySelector(CART_FORM + ' [name="id"]');
    return i ? i.value : null;
  }

  /* ── ajout au panier confirmé : on écoute le réseau, pas le bouton ──
     L'écart entre add_to_cart_click et add_to_cart révèle les échecs silencieux. */
  /** Shopify renvoie l'article réellement ajouté : c'est lui qui fait foi, pas la page
      (un accessoire ajouté depuis une fiche litière serait sinon compté comme la litière). */
  function trackAdded(payload) {
    var items = payload && payload.items ? payload.items : [payload];
    var vu = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.product_id) continue;
      vu = true;
      track('add_to_cart', {
        product_id: String(it.product_id),
        variant_id: it.variant_id ? String(it.variant_id) : null,
        label: it.product_title || it.title || null,
        value: typeof it.price === 'number' ? it.price / 100 : null,
        currency: 'EUR',
        meta: JSON.stringify({ qte: it.quantity || 1, variante: it.variant_title || null }),
      });
    }
    if (!vu) track('add_to_cart', { variant_id: currentVariant() });
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          // clone() : ne pas consommer le flux que le thème va lire lui aussi.
          r.clone().json().then(trackAdded).catch(function () {
            track('add_to_cart', { variant_id: currentVariant() });
          });
        }).catch(function () {});
      }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (String(url).indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { trackAdded(JSON.parse(this.responseText)); }
        catch (e) { track('add_to_cart', { variant_id: currentVariant() }); }
      });
    }
    return _open.apply(this, arguments);
  };

  /* ── profondeur de lecture ── */
  var marks = [25, 50, 75, 100], hit = {};
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var p = ((window.scrollY || window.pageYOffset) / h) * 100;
    for (var i = 0; i < marks.length; i++) {
      if (p >= marks[i] && !hit[marks[i]]) {
        hit[marks[i]] = 1;
        track('scroll_depth', { value: marks[i] });
      }
    }
  }
  var scrollTimer;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; onScroll(); }, 300);
  }, { passive: true });

  /* ── blocs réellement vus (depuis le 24/09/2026) ──
     `scroll_depth` est un pourcentage de la hauteur TOTALE : ajouter ou retirer une section
     déplace tous les jalons. Allonger la page de 16 à 19 écrans fait reculer le jalon « 25 % »
     de l'écran 3,8 à l'écran 4,65 : l'indicateur baisse alors que la page peut être meilleure,
     et deux versions ne sont plus comparables. `bloc_vu` est ancré sur le CONTENU : il traverse
     les refontes et dit quel bloc a été atteint, pas quelle fraction de hauteur.

     Un bloc compte comme vu quand la moitié de sa hauteur — ou un écran plein, pour les blocs
     plus hauts que la fenêtre — reste visible une seconde pleine. Sans ce délai, un défilement
     rapide jusqu'au pied de page marquerait tout comme lu.

     **L'entonnoir se lit sur `label`, jamais sur `value`.** `value` porte le rang du bloc
     dans la page le jour de la visite : il est commode pour ordonner un affichage, mais il
     glisse dès qu'une section est ajoutée ou retirée — y compris pour les sessions déjà en
     base. Seul le nom du bloc traverse les refontes.

     `meta.t` porte les secondes écoulées depuis l'arrivée : la différence entre deux blocs
     donne le temps passé sur celui du dessus, et le dernier `bloc_vu` d'une session donne son
     point de sortie. */
  (function () {
    if (!('IntersectionObserver' in window) || !document.querySelector) return;

    /** Nom stable et lisible, du repère le plus sûr au moins sûr.
        L'id interne d'abord : « cmk-odeurs-template--… » donne « odeurs ». Les classes viennent
        en dernier — la classe commune `cmk-landing` habille tous les blocs et les nommerait
        tous pareil (constaté au premier essai). */
    var ALIAS = { eb: 'email_banner', sto: 'sticky', faq: 'faq', app: 'application' };
    function nommer(el) {
      var interne = el.querySelector('[id^="cmk-"]');
      if (interne) {
        var mi = /^cmk-([a-z]+)/.exec(interne.id);
        if (mi) return ALIAS[mi[1]] || mi[1];
      }
      var ms = /__([a-z][a-z0-9_]*?)(?:_[0-9a-zA-Z]{6,})?$/.exec(el.id || '');
      if (ms) return ms[1].replace(/^cmk_/, '');
      var enfant = el.querySelector('[id]:not([id^="shopify-section"])');
      if (enfant && enfant.id) return enfant.id.slice(0, 24);
      return (el.id || 'bloc').replace(/^shopify-section-/, '').slice(0, 24);
    }

    /* Seulement les sections du GABARIT (« shopify-section-template--… »). Les groupes
       en-tête et pied de page en sont exclus : ce n'est pas du contenu, et le pied de page
       est fait de DEUX sections qui portaient le même nom, ce qui doublait tout total
       « a atteint le bas ». Ce filtre remplace un seuil de hauteur (> 120 px) qui était
       fragile : seize pixels de plus sur l'en-tête — une barre d'annonce, un changement de
       police — l'y auraient fait entrer et auraient décalé tous les rangs d'un cran. */
    var sections = [];
    try {
      sections = [].slice.call(document.querySelectorAll('[id*="shopify-section-template--"]'))
        .filter(function (el) { return el.offsetHeight > 120; });
    } catch (e) { return; }
    if (!sections.length) return;

    var vus = {}, attentes = {};
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var el = e.target, cle = el.id;
        if (vus[cle]) return;
        if (e.isIntersecting) {
          if (attentes[cle]) return;
          attentes[cle] = setTimeout(function () {
            attentes[cle] = null;
            if (vus[cle]) return;
            vus[cle] = 1;
            obs.unobserve(el);
            track('bloc_vu', {
              label: nommer(el),
              value: sections.indexOf(el) + 1,
              meta: metaP({ t: sec() }),
            });
          }, 1000);
        } else if (attentes[cle]) {
          clearTimeout(attentes[cle]); attentes[cle] = null;
        }
      });
    }, {
      // 50 % du bloc, ou un écran plein dès que le bloc dépasse la hauteur de la fenêtre.
      threshold: [0.5],
      rootMargin: '0px',
    });

    sections.forEach(function (el) {
      // Un bloc plus haut que la fenêtre n'atteindra jamais 50 % de visibilité : on l'observe
      // sur une bande centrale, franchie dès qu'un plein écran de ce bloc est à l'écran.
      if (el.offsetHeight > window.innerHeight) {
        new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) {
            var cle = el.id;
            if (vus[cle]) return;
            if (e.isIntersecting) {
              // Le même délai d'une seconde que les blocs courts : sans lui, un défilement
              // éclair jusqu'au pied de page marquait tous les grands blocs comme lus.
              if (attentes[cle]) return;
              attentes[cle] = setTimeout(function () {
                attentes[cle] = null;
                if (vus[cle]) return;
                vus[cle] = 1;
                track('bloc_vu', {
                  label: nommer(el),
                  value: sections.indexOf(el) + 1,
                  meta: metaP({ t: sec(), haut: 1 }),
                });
              }, 1000);
            } else if (attentes[cle]) {
              clearTimeout(attentes[cle]); attentes[cle] = null;
            }
          });
        }, { threshold: 0, rootMargin: '-40% 0px -40% 0px' }).observe(el);
      } else {
        obs.observe(el);
      }
    });
  })();

  /* ── clics de rage : 3 clics au même endroit en moins d'une seconde ── */
  var recent = [];
  document.addEventListener('click', function (ev) {
    var now = Date.now();
    recent = recent.filter(function (c) { return now - c.t < 1000; });
    recent.push({ t: now, x: ev.clientX, y: ev.clientY });
    if (recent.length >= 3) {
      var near = recent.every(function (c) {
        return Math.abs(c.x - recent[0].x) < 40 && Math.abs(c.y - recent[0].y) < 40;
      });
      if (near) {
        recent = [];
        var el = ev.target.closest ? ev.target.closest('button, a, [role="button"], div') : null;
        track('rage_click', {
          label: el ? ((el.className && String(el.className).slice(0, 60)) || el.tagName) : null,
        });
      }
    }
  }, true);

  /* ── temps passé ── */
  var arrived = Date.now(), firstClick = null;
  document.addEventListener('click', function (ev) {
    if (firstClick === null) {
      firstClick = Date.now() - arrived;
      track('first_click', { value: Math.round(firstClick / 1000), label: cible(ev.target),
                             meta: metaP({ t: sec() }) });
    }
  }, { once: true, capture: true });

  /** Ce qui a été touché, en clair : zone connue, sinon balise, classe et texte. */
  function cible(el) {
    if (!el || !el.closest) return null;
    if (el.closest('ul.l4pr')) return 'galerie';
    if (el.closest('[data-pas-etape], .pas__etape')) return 'selecteur_offre';
    // Sticky d'achat maison (snippets/cmk-sticky-offre.liquid) ; #sticky-add-to-cart est celui du
    // thème, encore présent sur les autres fiches.
    if (el.closest('[data-cmk-sto]')) return 'sticky';
    if (el.closest('#sticky-add-to-cart')) return 'barre_achat';
    var x = el.closest('a, button, summary, label, input, select, [role="button"]') || el;
    var c = typeof x.className === 'string' ? x.className.split(' ')[0] : '';
    var txt = (x.getAttribute('aria-label') || x.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    return (x.tagName.toLowerCase() + (c ? '.' + c : '') + (txt ? ' ' + txt : '')).slice(0, 80);
  }

  /* ── premier écran : combien de temps avant de défiler ──
     Seuil de 60 px : la barre d'adresse mobile qui se replie ne compte pas. */
  var defile = false;
  window.addEventListener('scroll', function () {
    if (defile || (window.scrollY || window.pageYOffset) < 60) return;
    defile = true;
    track('first_scroll', { value: sec(), meta: metaP({ g: galNb }) });
  }, { passive: true });

  /* ── premier écran : la galerie ──
     Carrousel Swiper du thème : la photo affichée porte .swiper-slide-active et son rang dans
     data-swiper-slide-index. Un événement par photo vue pour la première fois. */
  var galVues = { 0: 1 }, galNb = 1, galActuelle = 0, galChange = 0;
  (function () {
    var ul = document.querySelector('.m6pr ul.l4pr') || document.querySelector('ul.l4pr');
    if (!ul || !window.MutationObserver) return;
    new MutationObserver(function () {
      var a = ul.querySelector('.swiper-slide-active[data-swiper-slide-index]');
      if (!a) return;
      var i = parseInt(a.getAttribute('data-swiper-slide-index'), 10);
      if (isNaN(i) || i === galActuelle) return;
      galActuelle = i; galChange = Date.now();
      if (galVues[i]) return;
      galVues[i] = 1; galNb++;
      track('galerie', { value: i + 1, meta: metaP({ n: galNb, t: sec() }) });
    }).observe(ul, { attributes: true, attributeFilter: ['class'], subtree: true });
  })();

  /* ── vitesse vécue ──
     Mesures standard du navigateur, envoyées une fois, quand la page est quittée ou masquée.
     Safari ne fournit ni LCP ni INP : ces champs restent vides chez lui. */
  var perf = { cls: 0, inp: 0 }, perfEnvoye = false;
  function observer(type, cb, extra) {
    try {
      var o = { type: type, buffered: true };
      if (extra) for (var k in extra) o[k] = extra[k];
      new PerformanceObserver(function (l) { l.getEntries().forEach(cb); }).observe(o);
    } catch (e) {}
  }
  observer('paint', function (e) { if (e.name === 'first-contentful-paint') perf.fcp = Math.round(e.startTime); });
  // Le carrousel reconstruit la galerie : l'image d'origine est souvent détachée et e.element
  // vaut null. L'URL de l'image, elle, reste disponible.
  observer('largest-contentful-paint', function (e) {
    perf.lcp = Math.round(e.startTime);
    perf.le = decrire(e.element) || (e.url ? 'img ' + e.url.split('/').pop().split('?')[0].slice(0, 40) : null);
  });
  observer('layout-shift', function (e) { if (!e.hadRecentInput) perf.cls += e.value; });
  observer('event', function (e) { if (e.interactionId && e.duration > perf.inp) perf.inp = Math.round(e.duration); },
           { durationThreshold: 40 });
  function decrire(el) {
    if (!el || !el.tagName) return null;
    var s = el.tagName.toLowerCase(), c = typeof el.className === 'string' ? el.className.split(' ')[0] : '';
    if (c) s += '.' + c;
    var src = el.currentSrc || el.src || '';
    if (src) s += ' ' + src.split('/').pop().split('?')[0].slice(0, 28);
    if (el.closest && el.closest('ul.l4pr')) s = 'galerie ' + s;
    return s.slice(0, 70);
  }
  function envoyerPerf() {
    if (perfEnvoye) return;
    perfEnvoye = true;
    var m = { fcp: perf.fcp || null, lcp: perf.lcp || null, le: perf.le || null,
              cls: Math.round(perf.cls * 1000) / 1000, inp: perf.inp || null };
    try {
      var n = performance.getEntriesByType('navigation')[0];
      if (n) {
        m.ttfb = Math.round(n.responseStart);
        m.dcl = Math.round(n.domContentLoadedEventEnd) || null;
        m.load = Math.round(n.loadEventEnd) || null;
        m.ko = Math.round((n.transferSize || 0) / 1024) || null;
      }
    } catch (e) {}
    track('perf', { value: m.lcp, meta: metaP(m) });
  }

  /* ── retour sur un onglet restauré depuis le cache du navigateur ──
     Safari iOS rouvre souvent l'onglet laissé ouvert sans recharger la page : le script ne
     se relance pas et la visite passe inaperçue (Clarity, lui, la voit). On la rattrape ici. */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    var inactif = Date.now() - (+(st('cmk_seen') || 0));
    if (inactif > SESSION_MAX_IDLE) {
      sessionId = st('cmk_sid', uid()) || uid();
      clarityTagge = false; // la nouvelle session doit aussi porter son ID dans Clarity
      attribPushed = false; // et remplacer l'ancienne dans les attributs du panier
    }
    arrived = Date.now();
    base = now();
    hit = {};
    track('page_view', { label: 'retour (onglet restauré)', value: Math.round(inactif / 1000) });
    if (CFG.productId) track('product_view', { value: CFG.productPrice || null, currency: 'EUR' });
    flush(false);
  });

  function leave() {
    envoyerPerf();
    track('page_leave', { value: Math.round((Date.now() - arrived) / 1000) });
    flush(true);
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { envoyerPerf(); flush(true); }
  });
})();
